/**
 * Base class for welcome screens
 * Shows background design with bubbles
 * show arrows back / next
 */
fx.ns("shared.screens", class BaseChoiceScreen extends fx.components.PopupPanel
{
    constructor(options)
    {
        super();

        this._showBack = options && options.back !== undefined ? options.back : true;
        this._showNext = options && options.next !== undefined ? options.next : true;

        this.mode = "";

        this.showEffect = "hslideout";
		this.hideEffect = "hslidein";

        this.destroyOnSwitch = true;

        this._containerHeight = "fill";

        this._styleChoice = "circle"; // circle or square

        this._choiceClass = shared.components.ProductChoice;

        this._choices = [];
    }

    get choiceClass()
    {
        return this._choiceClass;
    }

    set choiceClass(val)
    {
        this._choiceClass = val;
    }

    get title()
    {
        return this._title;
    }

    set title(val)
    {
        this._title = val;
    }

    get containerHeight()
    {
        return this._containerHeight;
    }

    set containerHeight(val)
    {
        this._containerHeight = val;
    }

    get styleChoice()
    {
        return this._styleChoice;
    }

    set styleChoice(val)
    {
        this._styleChoice = val;
    }


    get choices()
    {
        return this._choices;
    }

    set choices(val)
    {
        this._choices = val;
    }

    get currentChoice()
    {
        return this._currentChoice;
    }

    set currentChoice(val)
    {
        this._currentChoice = val;
    }

    get showBack()
    {
        return this._showBack;
    }

    set showBack(value)
    {
        this._showBack = value;
        this._updateNavigation();
    }

    get showNext()
    {
        return this._showNext;
    }

    set showNext(value)
    {
        this._showNext = value;
        this._updateNavigation();
    }

    get valign()
    {
        return this._valign;
    }

    // set vertical align
    set valign(val)
    {
        this._valign = val;
        this._setAlign();
    }

    // to override : whether the order flow lets the customer leave without choosing
    get canSkip()
    {
        return true;
    }

    // order flow : the album price with that choice
    orderPriceLabel(price)
    {
        return fx.text("Prix : <strong>$ €</strong>", price.toFixed(2));
    }

    // order flow : what a choice adds to (or takes off) the current one
    orderPriceDifference(difference)
    {
        return "<strong>" + (difference < 0 ? "-" : "+") + Math.abs(difference).toFixed(2) + " €</strong>";
    }

    // to override
    onChoiceClicked(choice)
    {

    }


    create()
    {
        // asked by the order button : the screen stands on its own, so it carries its
        // own navigation. Inside the info panel the navigation is the panel's one.
        if (this.data && this.data.preOrderChoices)
        {
            this._showBack = true;
            this._showNext = this.canSkip;
        }

        super.create();

        if (this._showBack)
        {
            this.backButton = new fx.components.Button({label: fx.text("Revenir"), icon : fx.get("assets").arrowBack, className : "navigation"});
            this.addChild( this.backButton, {top : 0, left : 0});
        }

        if (this._showNext)
        {
            this.nextButton = new fx.components.Button({label: fx.text("Passer"), className : "navigation"});
            this.addChild( this.nextButton, {top : 0, right : 10});
        }

        if (this.choices.length > 0)
            this.build();
    }

    build()
    {
        this.container = new fx.components.VBox("container " + (fx.browser.isDesktop ? "horizontal" : "vertical"));
        this.addChild( this.container, {top : fx.browser.isDesktop ? "center" : 60, left : 0, width : "100%", height : fx.browser.isDesktop ? this.containerHeight : "fill"});        
        this.addTitle( this.title );
        if (this.subtitle)
            this.addSubText( this.subtitle );

        if (fx.browser.isDesktop)
        {
            this.hContainer = new fx.components.HBox({className: "hcontainer center", align:""});
            this.hContainer.valign = this.valign;
            this.container.addChild(this.hContainer, {width:"100%", height: "fill"});

            this._setAlign();
        }
      
        for (let i = 0; i < this.choices.length; i++)
        {
            let choice = this.choices.getItemAt(i);

            let component = new this._choiceClass(this.styleChoice, choice.data, choice.asset, choice.name, choice.description, choice.price, choice.disabled);
            
             this.addChoice(component);

            if (this._currentChoice && choice.data == this._currentChoice)
                component.addClass("selected")

            if (choice.disabled)
                component.addClass("not-available");

           
        }
    }

    addTitle(text)
    {
        this.container.addChild( new fx.components.Text( {text : text , className : "title" } ), {width:"90%", height : fx.browser.isDesktop ? 50 : 50, left:"center"});
    }

    addSubText(text)
    {
        this.container.addChild( new fx.components.Text( {text : text , className : "subtitle" } ), {width:"90%", height : fx.browser.isDesktop ? 40 : 65, left:"center"});
    }

    addChoice(choice, viewport)
    {
        if (fx.browser.isDesktop)
            this.hContainer.addChild( choice, viewport || {width: 190, height : 270} );
        else
            this.container.addChild( choice, viewport || {width: 190, height : 270, left : "center"} );
    }

    onReady()
    {
        super.onReady();

        this._updateNavigation();

        if (this.backButton)
        {
            this.on("click", this.onBack, this.backButton);
            this.on("ESCAPE", this.onBack, fx.keyboard);
        }
            

        if (this.nextButton)
            this.on("click", this.onNext, this.nextButton);

        this.on("click", this.onClick, this.container);
    }


    _updateNavigation()
    {
        if (this.backButton)
            this.backButton.toggle(this._showBack);

        if (this.nextButton)
            this.nextButton.toggle(this._showNext);
    }

    _setAlign()
    {
        if (!this.initialized)
            return;

        this.hContainer.valign = this.valign;
    }

    onClick(e)
    {
        // a click can still reach a destroyed screen, whose fields fx.Disposable.free has deleted (FlexiTrack #523)
        if (!this._choiceClass)
            return;

        // null when the click is outside a choice, or on a node whose component is gone
        let child = this.getChildFromUI(fx.dom.parent(e.target, "." + this._choiceClass.name));
        if (child)
            this.onChoiceClicked( child.data );
    }

    onBack()
    {
        if (!this.data)
            return;

        this.data.event(this.data.preOrderChoices ? "creation-choice-previous" : "previous-step");
    }

    onNext()
    {
        if (!this.data)
            return;

        // skipped : nothing picked here, go on with the following screen
        this.data.event(this.data.preOrderChoices ? "creation-choice-done" : "next-step");
    }

});
    